<div class="section-margin">
    <div class="col-md-12">
        <div class="text-right margin-bottom-15">
            <a class="btn  btn-circle btn-green" href="javascript:void(0);" tooltip="Add Expenses" placement="left" triggers="mouseenter:mouseleave" (click)="openModalForAddOrEdit(AddOrEditTemplate,'panlestyle',0,null)"><i aria-hidden="true" class="icofont icofont-plus icon"></i></a>
        </div>
        <div class="table-responsive">
            <table class="table basictable">
                <thead>
                  <tr>
                    <th style="width:120px;">Action</th>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Category</th>
                    <!--<th>Last Modified</th>-->
                    <th>Paid/Projection</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of offerDetailExpenseModelList">
                    <td class="whitespacenowrap">
                      <a class="blueone" href="javascript:void(0);" (click)="openModalForAddOrEdit(AddOrEditTemplate,'panlestyle',item.LeadExpenseId,item)" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></a>
                    </td>
                    <td><p>{{item.ExpenseDate| date:'M/d/yyyy'}}</td>
                    <td><p>{{item.Description}}</p></td>
                    <td><p class="whitespacenowrap">{{'$ '+ (item.Amount|number)}}</p></td>
                    <td><p>{{item.Category}}</p></td>
                    <!--<td><p>02/02/2018 10:00 AM</p></td>-->
                    <td><p>{{item.PaidStatusName}}</p></td>

                  </tr>

                    <tr *ngIf="offerDetailExpenseModelList?.length != 0 ">
                        <td></td>
                        <td><p><strong>Total</strong></p></td>
                        <td colspan="5"><p class="whitespacenowrap"><strong>{{'$ '+ (totalAmount|number)}}</strong></p></td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr *ngIf="offerDetailExpenseModelList?.length == 0 ">
                        <td colspan="7" class="odd no-data-available">
                            <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
<div class="clearfix"></div>

</div>

<ng-template #AddOrEditTemplate class="pull-left">

    <div class="modal-header">
        <h4 class="modal-title pull-left">{{labelForAddOrEdit}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <label class="form-label">Amount<span class="red">*</span></label>
            <div class="textbox-with-btn-left">
              <input class="form-control" #amountinput="ngModel"
                value="{{offerDetailExpenseModel.Amount|number}}" 
               [(ngModel)]="offerDetailExpenseModel.Amount" required type="text" (ngModelChange)="amountValidation()"
               currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"
               dropSpecialCharacters="false" >
              <span class="leftlabel">$</span>
            </div>
            <p class="redtext" *ngIf="(amountValid&&isSubmitted || (amountinput.invalid && amountinput.touched&&amountinput.dirty))">Amount is required </p>
        </div>
        <div class="form-group">
            <label class="form-label">Description</label>
            <input class="form-control" [(ngModel)]="offerDetailExpenseModel.Description" type="text" maxlength="199">
        </div>
        <div class="form-group">
            <label class="form-label">Category<span class="red">*</span></label>
            <label class="select">              
                <select class="form-control" #categoryinput="ngModel" [(ngModel)]="offerDetailExpenseModel.CategoryId">
                    <option value="0">Select</option>
                    <option [ngValue]="item.id" *ngFor="let item of categoryList">{{item.name}}</option>
                </select>
                <i></i>
            </label>
            <div *ngIf="(categoryValid&&isSubmitted || (categoryinput.invalid && categoryinput.touched&&categoryinput.dirty))">
                <p class="redtext"> Category is required </p>
            </div>

        </div>

        <div class="form-group">
            <label class="form-label">
                Paid Status
                <span class="star">*</span>
            </label>
            <label class="select">
                <select class="form-control" #paidStatusInput [(ngModel)]="offerDetailExpenseModel.PaidStatusId" (ngModelChange)="paidStatusValidation()">
                    <option value="null">Select</option>
                    <option [ngValue]="item.id" *ngFor="let item of paidStatusList">{{item.description}}</option>
                </select>
                <i></i>
            </label>
            <div *ngIf="(paidStatusValid || (paidStatusInput.invalid && paidStatusInput.touched))">
                <p class="redtext"> Paid Status is required </p>
            </div>
        </div>

        <div class="form-group">
            <label class="form-label">Expense Date<span class="red">*</span></label>
            <div class="textbox-date">
                <input type="text" placement="top" maxlength="10" (keydown)="onKeydown($event,'tab1')" required #expenseDateInput [(ngModel)]="offerDetailExpenseModel.ExpenseDate" (ngModelChange)="expenseDateValidation()" class="form-control" bsDatepicker />
                <i class="icofont icofont-ui-calendar icon"></i>
            </div>
            <div *ngIf="(expenseDateValid || (expenseDateInput.invalid && expenseDateInput.touched))">
                <p class="redtext">Expense Date is required </p>
            </div>
        </div>

        <div class="text-right">
            <button class="btn btn-lg btn-default" id="closeModal" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-success" [disabled]="disabledAddOrEditBtn" (click)="saveOfferExpense();">Save</button>
        </div>
    </div>

</ng-template>
